import { PRE_ONBOARDING_VIDEO } from "../../config/links";
import { VideoEmbed } from "./resources/VideoEmbed";
import styles from "./OnboardingVideo.module.css";

// The walkthrough on the locked-instance card. Until a video is configured it
// renders a same-size placeholder, so the card's layout is final without it.
export const OnboardingVideo = (): JSX.Element =>
  PRE_ONBOARDING_VIDEO !== null ? (
    <VideoEmbed
      provider={PRE_ONBOARDING_VIDEO.provider}
      videoId={PRE_ONBOARDING_VIDEO.videoId}
      title="ZeroToClaw onboarding walkthrough"
    />
  ) : (
    <div className={styles.frame}>
      <div className={styles.placeholder}>
        <span className={styles.playMark} aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M5 3.5v11l9-5.5-9-5.5z" fill="currentColor" />
          </svg>
        </span>
        <span>Walkthrough video coming soon</span>
      </div>
    </div>
  );
